<dx-form
  #updateRequestForm
  [formData]="externalRequestForm"
  [showColonAfterLabel]="false"
  labelMode="floating"
>
  <dxi-item itemType="group">
    <dxo-col-count-by-screen
      [xs]="1"
      [sm]="1"
      [md]="1"
      [lg]="4"
    ></dxo-col-count-by-screen>
    <dxi-item dataField="certificateFile" colSpan="4">
      <div *dxTemplate>
        <div id="dropzone-external" class="dropzone" [ngClass]="isDropZoneActive ? 'dropzone-active' : null" (click)="resetSkipAI($event)">
          <div class="dropzone-image-container">
            <img class="dropzone-image" src="assets/img/logo-ai.png" alt="upload-icon" />
          </div>
          <div class="dropzone-text">
            <span>{{"COMMON.UPLOAD-AI-DRAG-DROP-1" | translate}}</span>
            <span>{{"COMMON.UPLOAD-AI-DRAG-DROP-2" | translate}}</span>
          </div>
        </div>
        <div class="manual-upload-container">
          <dx-button type="default" [text]="'COMMON.UPLOAD-MANUALLY' | translate" (onClick)="onUploadSkipAI()"></dx-button> 
        </div>
        <div class="certificate-uploader-wrapper">
          <dx-file-uploader
            #filesUploader
            dialogTrigger="#dropzone-external"
            dropZone="#dropzone-external"
            class="certificate-uploader"
            [selectButtonText]="'COMMON.CHOOSE-FILE' | translate"
            [labelText]="'COMMON.UPLOAD-ATTACHMENT' | translate"
            [multiple]="false"
            accept="application/pdf"
            (valueChange)="onSelectedFileChange($event)"
            uploadMode="useButtons"
            (onDropZoneEnter)="onDropZoneEnter($event)"
            (onDropZoneLeave)="onDropZoneLeave($event)"
            (onUploaded)="onUpload($event)"
          >
          </dx-file-uploader>
          @if(externalRequestForm.certificateFile) {
            <div (click)="removeFile()">
              <i class="dx-icon-close"></i>
            </div>
          }
        </div>
      </div>
    </dxi-item>
  </dxi-item>
  <dxi-item dataField="name">
    <dxo-label [text]="'COMMON.FIELDS.TITLE' | translate"></dxo-label>
    <dxi-validation-rule
      type="required"
      [message]="'VALIDATIONS.TITLE-REQUIRED' | translate"
    ></dxi-validation-rule>
  </dxi-item>
  <dxi-item
    dataField="description"
    editorType="dxTextArea"
    cssClass="certificate-description"
  >
    <dxo-label
      [text]="'COMMON.FIELDS.DESCRIPTION' | translate"
    ></dxo-label>
    <dxi-validation-rule
      type="required"
      [message]="'VALIDATIONS.DESCRIPTION-REQUIRED' | translate"
    ></dxi-validation-rule>
  </dxi-item>
  <dxi-item itemType="group">
    <dxo-col-count-by-screen
      [xs]="1"
      [sm]="1"
      [md]="1"
      [lg]="2"
    ></dxo-col-count-by-screen>
    <dxi-item
      [editorOptions]="trainingTypeOptions"
      dataField="trainingType"
      editorType="dxSelectBox"
    >
      <dxo-label [text]="'COMMON.FIELDS.TRAINING-TYPE' | translate"></dxo-label>
      <dxi-validation-rule
        type="required"
        [message]="'VALIDATIONS.TRAINING-TYPE-REQUIRED' | translate"
      ></dxi-validation-rule>
    </dxi-item>
    <dxi-item dataField="date" editorType="dxDateBox">
      <dxo-label [text]="'COMMON.FIELDS.DATE' | translate"></dxo-label>
      <dxi-validation-rule
        type="required"
        [message]="'VALIDATIONS.DATE-REQUIRED' | translate"
      ></dxi-validation-rule>
    </dxi-item>
    @if(externalRequestForm.trainingType === 0) {
      <dxi-item>
        <app-time-picker
          [isInvalid]="!isTimeValid()"
          [disabled]="false"
          (timeChanged)="handleTimePicker($event)"
          [defaultValue]="{
            hours: externalRequestForm.iddHours!,
            minutes: externalRequestForm.iddMinutes!
          }"
          [validationMessage]="'VALIDATIONS.TRAINING-TIME-MINUTE' | translate"
        ></app-time-picker>
      </dxi-item>
    }
    <dxi-item dataField="location">
      <div *dxTemplate>
        <dx-autocomplete
          [(value)]="googleSearchText"
          [searchExpr]="autocompleteSearchFilter"
          [label]="'COMMON.FIELDS.TRAINING-LOCATION' | translate"
          [label]="'TRAINING.FORM.SEARCH-TRAINING-LOCATION' | translate"
          [dataSource]="googlePlaces"
          valueExpr="description"
          (onValueChanged)="getGooglePlaces($event)"
          (onItemClick)="setLocationPlace($event)"
          [readOnly]="false"
          labelMode="floating"
          stylingMode="outlined"
        >
        </dx-autocomplete>
      </div>
    </dxi-item>
    <dxi-item dataField="trainingCategoryId">
      <div *dxTemplate>
        <dx-drop-down-box
          #trainingCategoryDropDown
          [(value)]="externalRequestForm.trainingCategoryId"
          [inputAttr]="{ 'aria-label': 'Owner' }"
          valueExpr="id"
          displayExpr="name"
          [label]="('COMMON.FIELDS.TRAINING-CATEGORY' | translate)"
          [dataSource]="trainingCategories"
          labelMode="floating"
          stylingMode="outlined"
          (onValueChanged)="trainingCategoryDropDown.instance.close()"
        >
          <div *dxTemplate="let data of 'content'">
            <dx-tree-view
              [searchEnabled]="true"
              [dataSource]="trainingCategories"
              keyExpr="id"
              [selectNodesRecursive]="false"
              displayExpr="name"
              (onItemClick)="onTrainingCategorySelected($event)"
            >
            </dx-tree-view>
          </div>
        </dx-drop-down-box>
      </div>
    </dxi-item>
  </dxi-item>
</dx-form>
<div class="cta-button">
  <dx-button
    [text]="'COMMON.SAVE' | translate"
    type="normal"
    (click)="onFormSubmit()"
  ></dx-button>
</div>
